/* eslint-disable */
import {
  httpAxios,
  keyDataReducer,
  extractTripDetails,
  apiPostHelper,
  apiGetHelper,
  apiPutHelper,
  isInFlyinDomain
} from 'AccountsUtils'
import {
  FETCH_TRIPS_DETAILS_V2,
  BFF_FETCH_TRIPS_DETAILS_V2,
  NEW_FETCH_TRIP_FAQS,
  BFF_NEW_FETCH_TRIP_FAQS,
  FETCH_TRIPS_DETAILS,
  FETCH_TRIP_CASE_DETAIL,
  AUTHENTICATE_CONTENT,
  BFF_AUTHENTICATE_CONTENT,
  OTP_LOGIN_TRIPID,
  PUT_CALL,
  POST_CALL,
  GET_CALL,
  OTP_VERIFY_TRIPID,
  USER_SIGN_IN,
  USER_RESET_PASSWORD,
  // FACEBOOK_LOGIN_API,
  USER_SIGN_UP,
  GET_USER_BY_EMAIL,
  CAPTCH_VERIFY,
  FETCH_TRIP_PROMO_DETAIL,
  AB_TEST_CONFIG_DESKTOP,
  AB_TEST_CONFIG_PWA
} from 'AccountsConstants/api_endpoints'
import { getCookie, isEmpty, setCookie } from '../../utils/index'

export const fetchTripDetails = (tripId, mock = true, fetchControl = 'MAIN') => {
  const isFlyin = isInFlyinDomain()
  const url = isFlyin
    ? `${BFF_FETCH_TRIPS_DETAILS_V2}${tripId}`
    : (mock ? `${FETCH_TRIPS_DETAILS_V2}${tripId}` : `${FETCH_TRIPS_DETAILS}${tripId}`)

  const extraHeaders = isFlyin && fetchControl === 'LINKED' ? { 'fetch-control': 'LINKED' } : {}
  
  const newPromise = new Promise((resolve, reject) => {
    httpAxios(url, GET_CALL, undefined, true, false, false, extraHeaders)
      .then(res => {
        let response = null
        if (res && res.status === 200) {
          response = res.data
        }
        resolve(response)
      })
      .catch(err => reject(err))
  })
  return newPromise
}

const travellerCountReducer = (travellersData, list = [], count) => {
  let newList = list
  let newCount = count
  if (Array.isArray(travellersData)) {
    newList =
      travellersData && travellersData.length > 0
        ? newList.concat(travellersData)
        : newList
    newCount = newList.length
  } else if (
    typeof travellersData === 'object' &&
    !Array.isArray(travellersData) &&
    travellersData
  ) {
    newCount = Object.values(travellersData).reduce((init, travellerItem) => {
      let newInit = init
      if (!Number.isNaN(travellerItem)) {
        newInit += travellerItem
      }
      return newInit
    }, 0)
  }
  return { list: newList, count: newCount }
}
const travellerModifyMarker = (travellers, flag, key) => {
  let newFlag = flag
  let partialFlag = false
  let cancelCount = 0
  let modifyCount = 0
  if (travellers && travellers.length > 0 && !newFlag) {
    travellers.forEach(item => {
      const status = item && item[key] ? item[key] : null
      if (status === 'cancelled') {
        cancelCount += 1
      }
      if (['upcoming', 'confirmed'].indexOf(status) === -1) {
        modifyCount += 1
      }
      newFlag = ['upcoming', 'confirmed'].indexOf(status) === -1
    })
  }
  if (cancelCount === travellers.length) {
    newFlag = false
  } else {
    partialFlag = travellers.length !== modifyCount
  }
  return { newFlag, partialFlag }
}
export const extractTravellers = (data, verticalArray = []) => {
  let returnData = null
  if (data && verticalArray) {
    returnData = { list: [], modify: false, count: 0, partial: false }
    verticalArray.forEach(verticalItem => {
      const { tripDetails, travellers, travellerDetails, travellerStatus } =
        verticalItem || {}
      if (tripDetails && travellers) {
        let details = extractTripDetails(data, tripDetails)
        details = details && Array.isArray(details) ? details[0] : details
        if (details && travellers) {
          details = travellerDetails
            ? keyDataReducer(details, travellerDetails)
            : details
          if (Array.isArray(details)) {
            const travellersData = details[0]
              ? keyDataReducer({ ...details[0] }, travellers)
              : {}
            returnData = {
              ...returnData,
              ...travellerCountReducer(
                travellersData,
                returnData.list,
                returnData.count
              )
            }
          }
        }
      }
      if (
        returnData &&
        returnData.list &&
        returnData.list.length > 0 &&
        !returnData.modify
      ) {
        const { list, modify } = returnData
        const { newFlag, partialFlag } = travellerModifyMarker(
          list,
          modify,
          travellerStatus
        )
        returnData.modify = newFlag
        returnData.partial = partialFlag
      }
    })
  }
  return returnData
}

export const fetchTripFAQ = (tripId = null, fetchControl) => {
  const isFlyin = isInFlyinDomain()
  const urlParams = new URLSearchParams(window.location.search)
  const faqsBase = isFlyin ? BFF_NEW_FETCH_TRIP_FAQS : NEW_FETCH_TRIP_FAQS
  const url = tripId ? `${faqsBase}${tripId}` : faqsBase

  const effectiveFetchControl = fetchControl || (urlParams.get('account') === 'LINKED' ? 'LINKED' : 'MAIN')
  const extraHeaders = isFlyin && effectiveFetchControl === 'LINKED' ? { 'fetch-control': 'LINKED' } : {}
  
  const newPromise = new Promise((resolve, reject) => {
    httpAxios(url, GET_CALL, '', true, false, false, extraHeaders)
      .then(res => {
        let response = null
        if (res && res.status === 200) {
          response = res.data
        }
        resolve(response)
      })
      .catch(err => reject(err))
  })
  return newPromise
}

export const fetchTripCaseDetails = (tripId) => {
  const url = `${FETCH_TRIP_CASE_DETAIL}${tripId}`
  const newPromise = new Promise((resolve, reject) => {
    httpAxios(url)
      .then(res => {
        let response = null
        if (res && res.status === 200) {
          response = res.data
        }
        resolve(response)
      })
      .catch(err => reject(err))
  })
  return newPromise
}

export const fetchPromoInfo = tripId => {
  const url = `${FETCH_TRIP_PROMO_DETAIL}${tripId}?promoType=SUPERCOINS`
  const newPromise = new Promise((resolve, reject) => {
    httpAxios(url)
      .then(res => {
        let response = null
        if (res && res.status === 200) {
          response = res.data
        }
        resolve(response)
      })
      .catch(err => reject(err))
  })
  return newPromise
}

export const supportByTripId = (tripId, otp = null) => {
  let url = `${OTP_LOGIN_TRIPID}?tripRef=${tripId}&source=accountpwa`
  if (otp != null) {
    url = `${OTP_VERIFY_TRIPID}?tripRef=${tripId}&source=accountpwa&otp=${otp}`
  }
  const newPromise = new Promise((resolve, reject) => {
    httpAxios(url, PUT_CALL)
      .then(res => {
        let response = null
        if (res) {
          response = {
            status: 200,
            ...res.data
          }
        }
        resolve(response)
      })
      .catch(err => {
        if (
          err.response.status === 404 ||
          err.response.status === 500 ||
          err.response.status === 401 ||
          err.response.status === 400
        ) {
          resolve(err.response)
        } else {
          resolve(err)
        }
      })
  })
  return newPromise
}

export const userSignIn = payload => {
  // const URL = `${DOMAIN}${appPrefix}/itinerary/${itineraryData.itineraryId}/user`
  // const URL = '//identity-microservice.cltp.com:9001/signin'
  const deviceIdCookie = getCookie("ct-dvId")
  const isEmptyDeviceIdCookie = isEmpty(deviceIdCookie)  
  !isEmptyDeviceIdCookie && setCookie('ct-dvId',deviceIdCookie)
  const url = `${USER_SIGN_IN}`
  // const URL = `${DOMAIN}${appPrefix}/itin/user/signin`
  const requestHeaders = {
    'X-CT-SOURCETYPE': 'pwa',
    service: window.location.pathname
  }
  const response = apiPostHelper(
    url,
    payload,
    true,
    'application/json',
    requestHeaders
  )
  return response
}

export const userSignUp = payload => {
  const URL = `${USER_SIGN_UP}`
  const requestHeaders = {
    'x-ct-caller-app': 'mobile',
    service: window.location.pathname
  }
  const response = apiPostHelper(
    URL,
    payload,
    true,
    'application/json',
    requestHeaders
  )
  return response
}

// export const userSignIn = payload => {
//   const url = `${USER_SIGN_IN}`
//   const newPromise = new Promise((resolve, reject) => {
//     httpAxios(url, POST_CALL, payload)
//       .then(res => {
//         let response = null
//         if (res) {
//           response = res
//         }
//         resolve(response)
//       })
//       .catch(err => resolve(err))
//   })
//   return newPromise
// }

// export const userSignUp = payload => {
//   const url = `${USER_SIGN_UP}`
//   const newPromise = new Promise((resolve, reject) => {
//     httpAxios(url, POST_CALL, payload)
//       .then(res => {
//         let response = null
//         if (res) {
//           response = res
//         }
//         resolve(response)
//       })
//       .catch(err => resolve(err))
//   })
//   return newPromise
// }

export const userResetPassword = email => {
  const url = `${USER_RESET_PASSWORD}?email=${email}`
  const newPromise = new Promise((resolve, reject) => {
    httpAxios(url, POST_CALL)
      .then(res => {
        let response = null
        if (res) {
          response = res
        }
        resolve(response)
      })
      .catch(err => resolve(err))
  })
  return newPromise
}

export const getUserByEmailId = email => {
  const url = `${GET_USER_BY_EMAIL}?domain=${process.env.webpackEnv === 'development'
    ? 'qa2.cleartrip.com'
    : 'www.cleartrip.com'
    }&emailId=${email}`
  const newPromise = new Promise((resolve, reject) => {
    httpAxios(url, GET_CALL, null, true, true)
      .then(res => {
        let response = null
        if (res) {
          response = res
        }
        resolve(response)
      })
      .catch(err => resolve(err))
  })
  return newPromise
}

export const captchaVerify = (e, captchaRespValue) => {
  const url = `${CAPTCH_VERIFY}?domain=${process.env.webpackEnv === 'development'
    ? 'qa2.cleartrip.com'
    : 'cleartrip.com'
    }&g-recaptcha-response=${captchaRespValue}`
  const newPromise = new Promise((resolve, reject) => {
    httpAxios(url, POST_CALL, null, true, true, true)
      .then(res => {
        let response = null
        if (res) {
          response = res
        }
        resolve(response)
      })
      .catch(err => resolve(err))
  })
  return newPromise
}

export const getAbTestConfigDesktop = async queryParam => {
  try {
    const response = await httpAxios(AB_TEST_CONFIG_DESKTOP, GET_CALL)
    return response
  } catch (err) {
    console.error(err)
  }
}

export const getAbTestConfigPWA = async queryParam => {
  try {
    const response = await httpAxios(AB_TEST_CONFIG_PWA, GET_CALL)
    return response
  } catch (err) {
    console.error(err)
  }
}
export const sendOtpForSignIn = async payload => {
  const deviceIdCookie = getCookie("ct-dvId")
  const isEmptyDeviceIdCookie = isEmpty(deviceIdCookie)  
  !isEmptyDeviceIdCookie && setCookie('ct-dvId',deviceIdCookie)
  const params = window?.location?.href
  const isPWA = params.indexOf('/m/support') !== -1
  const URL = '/accounts/external-api/otp'
  // console.log(payload)
  // return {
  //     status: 200,
  //     data: {
  //         comm_id: '200',
  //         status: '200',
  //         action: 'SIGN_UP'
  //     }
  // }
  const header = (payload?.type === 'MOBILE' && payload?.action === 'SIGNIN') ? {
    caller: `${window.location.host}`,
    'ab-otp': 'b'
  }:
  {
    caller: `${window.location.host}`
  }
  const response = apiPostHelper(URL, payload, isPWA, 'application/json', header)

  return response
}
export const verifyOtpForSignIn = async payload => {
  const deviceIdCookie = getCookie("ct-dvId")
  const isEmptyDeviceIdCookie = isEmpty(deviceIdCookie)  
  !isEmptyDeviceIdCookie && setCookie('ct-dvId',deviceIdCookie)
  const URL = '/accounts/external-api/otp/verify-action'
  // console.log(payload)
  // return {
  //     status: 200,
  //     data: {
  //         action: 'SIGNUP'
  //     }
  // }
  const params = window?.location?.href
  const isPWA = params.indexOf('/m/support') !== -1
  const header = (payload?.type === 'MOBILE' && payload?.action === 'SIGNIN') ? {
    caller: `${window.location.host}`,
    'ab-otp': 'b'
  }:
  {
    caller: `${window.location.host}`
  }
  const response = apiPostHelper(URL, payload, isPWA, 'application/json', header)
  return response
}

export const checkForLinkingNudge = async payload => {
  const URL = '/accounts/external-api/otp/verify-action'
  console.log(payload)
  // return {
  //     status: 200,
  //     data: {
  //         action: true
  //     }
  // }
  const response = apiPostHelper(URL, payload, true, 'application/json', {
    caller: `${window.location.host}`
  })
  return response
}
export const getLinkedEmailsList = async ({ mobileNumber, countryCode }) => {
  const URL = '/accounts/external-api/users'
  // console.log(URL)
  // return {
  //   status: 200,
  //   data: {
  //     users: [
  //       {
  //         id: '123',
  //         username: 'ashok.chitkara@chitkara.com'
  //       },
  //       {
  //         id: '12',
  //         username: 'a@a.com'
  //       },
  //       {
  //         id: '124',
  //         username: 'random@api.com'
  //       },
  //       {
  //         id: '123',
  //         username: 'as123@123cc.com'
  //       }
  //     ]
  //   }
  // }
  // return {
  //   status: 200,
  //   data: {
  //     users: []
  //   }
  // }
  const response = apiGetHelper(
    URL,
    true,
    {},
    { caller: `${window.location.host}` }
  )
  return response
}
export const getUserProfileDetails = () => {
  let URL = `/accounts-api/people/v2/fetch/details`
  if (process.env.CT_ENV !== 'production') {
    URL = `/people/v2/fetch/details`
  }

  const response = apiGetHelper(
    URL,
    true,
    {},
    { caller: `${window.location.host}` }
  )
  return response;
}

export const submitPersonalDetails = async payload => {
  const URL = '/accounts/external-api/user'
  console.log(payload)

  const response = apiPutHelper(URL, payload, true, 'application/json', {
    caller: `${window.location.host}`
  })
  return response
}

export const linkAccounts = async payload => {
  const URL = '/external-api/user'
  console.log(payload)
  return {
    status: 200
  }

  // const response = apiPutHelper(URL, payload, 'application/json')
  // return response
}

export const saveNudge = async type => {
  const URL = `/accounts/external-api/nudge?type=${type}`
  // console.log(payload)
  // return {
  //     status: 200
  // }

  const response = apiPostHelper(URL, null, true, 'application/json', {
    caller: `${window.location.host}`
  })
  return response
}
export const getUserByMobile = (mobile, countryCode) => {
  const code = encodeURIComponent(countryCode)
  let URL = `/accounts-api/people/v2/fetch?domain=${window.location.host
    }&mobile=${mobile}&countryCode=${code}`
  if (process.env.CT_ENV !== 'production') {
    URL = `/people/v2/fetch?domain=${window.location.host
      }&mobile=${mobile}&countryCode=${code}`
  }

  const response = apiGetHelper(URL, true, {})
  return response
}

export const getHiFiveDetails = () => {
  let URL = `/referral/details?action=HI_FIVE`
  const response = apiGetHelper(
    URL,
    true,
    {},
    { caller: `${window.location.host}` }
  )
  return response
}

export const generateReferralLink = () => {
  let URL = `/referral/link?action=HI_FIVE`

  const response = apiPostHelper(URL, {}, true, 'application/json', {
    caller: `${window.location.host}`
  })
  return response
}

export const saveHiFiveNudge = () => {

  let URL = `/referral/nudge?action=HI_FIVE&type=RESULT_SEEN`

  const response = apiPutHelper(URL, {}, true, 'application/json', {
    caller: `${window.location.host}`
  })
  return response
}
export const updateGst = async payload => {
  const URL = `/accounts/external-api/gst`
  const response = apiPostHelper(URL, payload, true, 'application/json', {
    caller: `${window.location.host}`
  })
  return response
}


export const getAuthenticated = async (fetchControl) => {
  const isFlyin = isInFlyinDomain()
  const URL = isFlyin ? BFF_AUTHENTICATE_CONTENT : AUTHENTICATE_CONTENT
  const params = new URLSearchParams(window.location.search)
  const effectiveFetchControl = fetchControl || (params.get('account') === 'LINKED' ? 'LINKED' : 'MAIN')
  const headers = isFlyin && effectiveFetchControl === 'LINKED' ? { 'fetch-control': 'LINKED' } : {}
  const response = apiGetHelper(
    URL,
    false,
    {},
    { caller: `${window.location.host}`, ...headers }
  )
  return response
}